import { render, staticRenderFns } from "./mo-min-max-wrapper.html?vue&type=template&id=f6176956&scoped=true&external"
import script from "./mo-min-max-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-min-max-wrapper.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-min-max-wrapper.vue?vue&type=style&index=0&id=f6176956&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6176956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/3/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6176956')) {
      api.createRecord('f6176956', component.options)
    } else {
      api.reload('f6176956', component.options)
    }
    module.hot.accept("./mo-min-max-wrapper.html?vue&type=template&id=f6176956&scoped=true&external", function () {
      api.rerender('f6176956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-min-max-wrapper/mo-min-max-wrapper.vue"
export default component.exports